/* PKW GUTACHTER - Bewegung
   ==========================================================================
   Dreierlei:
     1. Die Zahlen im Startbild zaehlen beim Erscheinen von null hoch.
     2. Die Karten fliegen beim Hereinscrollen von aussen ein.
     3. Die mitlaufende Bestellleiste unter dem Produktbild erscheint,
        sobald der Bestellbereich rechts oben im Bild ankommt.

   Wichtig ist der Unterschied zwischen 1./2. und 3.:

   1. und 2. sind Zierde. Sie verstecken vorher sichtbare Dinge, und das
   darf nur dieses Skript tun - in motion.css steht keine Regel, die von
   sich aus etwas unsichtbar macht. Laeuft das Skript nicht, steht die
   Seite vollstaendig da. Bei "Bewegung reduzieren" wird gar nicht erst
   angefangen. Und nach dem Einfliegen werden die Klassen wieder
   abgenommen, weil ihr transform:none sonst gegen .cat:hover und
   .prod:hover gewinnt und die Karte sich nicht mehr anheben laesst.

   3. ist kein Schmuck, sondern eine Bedienhilfe. Sie laeuft deshalb auch
   bei "Bewegung reduzieren" - dort nur ohne das Einblenden. Anders als
   oben ist die Leiste hier in CSS von Haus aus versteckt und wird per
   Klasse eingeblendet, nicht umgekehrt: sonst blitzte sie bei jedem
   Seitenaufruf einmal auf, bevor das Skript sie wegnehmen kann.
   ========================================================================== */
(function () {
  "use strict";

  var mq = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)");
  var ruhig = !!(mq && mq.matches);
  var hatIO = "IntersectionObserver" in window;

  /* ========================================================================
     1. Zahlenleiste im Startbild
     ======================================================================== */

  var ZAHL = /\d+(?:[.,]\d+)*/g;
  var DAUER = 1400;
  var listen = new Map();
  var zBeob = null;

  /*
     Zerlegt eine einzelne Zahl in Ziel, Nachkommastellen und Trennzeichen.
     "4,98" -> 4.98 mit zwei Stellen und Komma. "1.200" -> 1200 ohne
     Nachkomma, Punkt als Tausendertrenner. Unterschieden wird so:

       - beide Trenner vorhanden  -> der hintere ist der Dezimaltrenner
       - ein Trenner mehrfach     -> Tausendertrenner (1.200.000)
       - ein Trenner, genau drei Ziffern danach, hoechstens drei davor
                                  -> Tausendertrenner (1.200)
       - sonst                    -> Dezimaltrenner (4,98)

     Ein Grenzfall bleibt offen: "1,500" liest sich hier als 1500, nicht als
     eineinhalb. Auf einer Zahlenleiste ist das die haeufigere Bedeutung.
  */
  function lies(txt) {
    var iK = txt.lastIndexOf(","), iP = txt.lastIndexOf(".");
    var grp = "", sep = "", dec = 0;
    if (iK > -1 && iP > -1) {
      if (iK > iP) { sep = ","; grp = "."; } else { sep = "."; grp = ","; }
    } else if (iK > -1 || iP > -1) {
      var z = iK > -1 ? "," : ".";
      var pos = Math.max(iK, iP);
      if (txt.split(z).length - 1 > 1) { grp = z; }
      else if (txt.length - pos - 1 === 3 && pos <= 3) { grp = z; }
      else { sep = z; }
    }
    if (sep) { dec = txt.length - txt.lastIndexOf(sep) - 1; }
    var ziel = parseFloat(txt.replace(/[.,]/g, ""));
    if (!isFinite(ziel)) { return null; }
    if (dec) { ziel = ziel / Math.pow(10, dec); }
    return { ziel: ziel, dec: dec, sep: sep, grp: grp };
  }

  /* Zurueck in genau die Schreibweise, die vorher dastand. */
  function schreibe(wert, f) {
    var s = f.dec ? wert.toFixed(f.dec) : String(Math.round(wert));
    var t = s.split(".");
    var ganz = t[0];
    if (f.grp) { ganz = ganz.replace(/\B(?=(\d{3})+(?!\d))/g, f.grp); }
    return f.dec ? ganz + f.sep + t[1] : ganz;
  }

  /*
     Der Text wird zerlegt: jede Zahl bekommt ein eigenes span, alles
     dazwischen bleibt unveraenderter Text. Dadurch zaehlt "24/7" beide
     Zahlen einzeln hoch und der Schraegstrich bleibt stehen, ebenso das
     Sternchen in "4,98 *" und das Pluszeichen in "100+".

     Aufgebaut wird ueber createTextNode, nicht ueber innerHTML: der Text
     kommt aus den Section-Einstellungen, und was dort jemand eintippt,
     hat in einer HTML-Zuweisung nichts verloren.
  */
  function zerlege(el) {
    var txt = el.textContent, frag = document.createDocumentFragment();
    var teile = [], m, letzte = 0;
    ZAHL.lastIndex = 0;
    while ((m = ZAHL.exec(txt)) !== null) {
      var f = lies(m[0]);
      if (!f) { continue; }
      if (m.index > letzte) { frag.appendChild(document.createTextNode(txt.slice(letzte, m.index))); }
      var s = document.createElement("span");
      s.textContent = schreibe(0, f);
      frag.appendChild(s);
      teile.push({ el: s, f: f });
      letzte = m.index + m[0].length;
    }
    if (!teile.length) { return null; }
    if (letzte < txt.length) { frag.appendChild(document.createTextNode(txt.slice(letzte))); }
    el.textContent = "";
    el.appendChild(frag);
    return teile;
  }

  /* Ein Durchlauf fuer die ganze Leiste, nicht einer je Zahl: vier eigene
     Schleifen wuerden vier Mal je Bild dieselbe Arbeit anstossen. */
  function zaehle(teile) {
    var start = null;
    function bild(t) {
      if (start === null) { start = t; }
      var p = Math.min(1, (t - start) / DAUER);
      var e = 1 - Math.pow(1 - p, 3);   /* schnell los, weich aus */
      for (var i = 0; i < teile.length; i++) {
        teile[i].el.textContent = schreibe(teile[i].f.ziel * e, teile[i].f);
      }
      if (p < 1) { requestAnimationFrame(bild); }
    }
    requestAnimationFrame(bild);
  }

  function bereiteZahlen(leiste) {
    if (leiste.getAttribute("data-zaehler")) { return; }
    var teile = [];
    Array.prototype.forEach.call(leiste.querySelectorAll(".hstat-v"), function (el) {
      var t = zerlege(el);
      if (t) { teile = teile.concat(t); }
    });
    if (!teile.length) { return; }
    leiste.setAttribute("data-zaehler", "1");
    if (!zBeob) {
      zBeob = new IntersectionObserver(function (eintraege) {
        eintraege.forEach(function (e) {
          if (!e.isIntersecting) { return; }
          zBeob.unobserve(e.target);
          var d = listen.get(e.target);
          if (d) { listen.delete(e.target); zaehle(d); }
        });
      }, { threshold: 0.25 });
    }
    listen.set(leiste, teile);
    zBeob.observe(leiste);
  }

  /* ========================================================================
     2. Karten fliegen ein
     ======================================================================== */

  var ZIELE = ".feat4 .f, .cat, .t-card, .cta3 .c3, .prod";
  var kBeob = null;

  /*
     Die Richtung haengt an der Lage zur Bildschirmmitte, nicht an der
     Reihenfolge im Raster. Nach Reihenfolge zu gehen bricht, sobald sich
     die Spaltenzahl aendert: bei zwei Spalten liegt die dritte Karte
     wieder links, bei einer Spalte gibt es gar keine Seite mehr.

     Was naeher als ein Achtel der Fensterbreite an der Mitte steht, kommt
     von unten. Eine mittige Karte seitlich hereinzuziehen sieht nach
     Zufall aus.
  */
  function richtung(el) {
    var r = el.getBoundingClientRect();
    var abstand = (r.left + r.width / 2) - (window.innerWidth / 2);
    var schwelle = window.innerWidth / 8;
    if (abstand < -schwelle) { return "rv-l"; }
    if (abstand > schwelle) { return "rv-r"; }
    return "rv-u";
  }

  function loese(el) {
    var fertig = false;
    function ab() {
      if (fertig) { return; }
      fertig = true;
      el.removeEventListener("transitionend", ende);
      el.classList.remove("rv", "rv-l", "rv-r", "rv-u", "rv-go");
    }
    function ende(e) {
      if (e.target === el && e.propertyName === "transform") { ab(); }
    }
    el.addEventListener("transitionend", ende);
    /* Notausgang. transitionend kommt nicht an, wenn der Uebergang nie
       laeuft - etwa weil die Karte in einem Hintergrund-Tab hereingescrollt
       wurde. Ohne diesen Zeitgeber blieben die Klassen stehen und die Karte
       liesse sich nicht mehr anheben. */
    setTimeout(ab, 1400);
    el.classList.add("rv-go");
  }

  function bereiteKarten() {
    var alle = document.querySelectorAll(ZIELE);
    if (!alle.length) { return; }
    if (!kBeob) {
      kBeob = new IntersectionObserver(function (eintraege) {
        eintraege.forEach(function (e) {
          if (!e.isIntersecting) { return; }
          kBeob.unobserve(e.target);
          loese(e.target);
        });
      }, { rootMargin: "0px 0px -10% 0px", threshold: 0.1 });
    }
    Array.prototype.forEach.call(alle, function (el) {
      if (el.getAttribute("data-rv")) { return; }
      /* Nur verstecken, was beim Start ohnehin noch nicht im Bild steht.
         Eine Karte, die schon sichtbar ist, wuerde sonst kurz dastehen,
         verschwinden und wiederkommen - das faellt mehr auf als gar keine
         Bewegung. */
      if (el.getBoundingClientRect().top < window.innerHeight * 0.92) { return; }
      el.setAttribute("data-rv", "1");
      el.classList.add("rv", richtung(el));
      kBeob.observe(el);
    });
  }

  /* ========================================================================
     3. Die mitlaufende Bestellleiste unter dem Bild
     ======================================================================== */

  /*
     WANN SIE KOMMT - dritter Anlauf, und der Weg dahin gehoert dazu.

     Erst hing es am Bestellknopf selbst: ein Beobachter meldete, wenn der
     Knopf im Formular nach oben aus dem Bild lief. Beim Buch steht dieser
     Knopf bei 1038 Pixeln auf einer 4235 Pixel hohen Seite - man musste
     also rund ein Viertel der Seite scrollen, bevor die Leiste kam. Genau
     in diesem Viertel wird aber entschieden.

     Dann hing es an der Servicezeile ganz oben, gemessene 43 Pixel. Das
     war zu frueh, und zwar nicht wegen der Zahl: die Leiste bringt vier
     Haendlerknoepfe mit, und die standen nach einer Handbreit Scrollen
     neben zwei weiteren Haendlerknoepfen rechts. Erschlagen statt
     gefuehrt.

     Jetzt haengt es am Bestellbereich: sobald das Formular rechts unter
     die Kopfzeile rueckt, ist der Kunde in der Entscheidung - und ab da
     hilft die Leiste, statt zu draengen. Beim Buch sind das rund 570
     Pixel, also gut die halbe erste Bildschirmhoehe.

     Gemessen wird die Kopfzeile und nicht geschaetzt: sie ist sticky und
     verdeckt sonst genau den Bereich, auf den die Grenze zeigt.

     Nachgerechnet wird bei resize UND bei load. Beim Aufbau der Seite ist
     das Produktbild oft noch nicht da; die Grenze staende dann auf einem
     Formular, das nach dem Laden des Bildes hunderte Pixel tiefer sitzt.

     Unter 980 Pixeln Breite ist die Leiste per CSS ganz weg - auf dem
     Telefon steht ohnehin alles untereinander. Das hier laeuft dort mit,
     schaltet aber nur eine Klasse an etwas Unsichtbarem.

     data-cta2 bleibt als Marke stehen: im Theme-Editor wird eine Section
     beim Bearbeiten neu geladen und init() laeuft erneut. Ohne die Marke
     haengte bei jedem Durchgang ein weiterer Zuhoerer am Fenster.
  */
  function zweiterKnopf() {
    var box = document.querySelector(".pdp-cta2");
    if (!box || box.getAttribute("data-cta2")) { return; }
    box.setAttribute("data-cta2", "1");

    function hoehe() {
      return window.pageYOffset || document.documentElement.scrollTop || 0;
    }

    function grenze() {
      var form = document.querySelector(".pdp-info form");
      if (!form) { return 420; }
      var kopf = document.querySelector(".site-head");
      var rand = kopf ? Math.round(kopf.getBoundingClientRect().height) + 16 : 96;
      var g = Math.round(form.getBoundingClientRect().top + hoehe() - rand);
      return g < 60 ? 60 : g;
    }

    var g = grenze();

    function pruefe() { box.classList.toggle("an", hoehe() > g); }

    function neu() { g = grenze(); pruefe(); }

    window.addEventListener("scroll", pruefe, { passive: true });
    window.addEventListener("resize", neu);
    if (document.readyState === "complete") { pruefe(); }
    else { window.addEventListener("load", neu); }
    pruefe();
  }

  /* ========================================================================
     Start
     ======================================================================== */

  function init() {
    /* Zuerst die Bedienhilfe - sie laeuft unabhaengig davon, ob jemand
       Bewegung sehen will. */
    zweiterKnopf();

    if (ruhig || !hatIO) { return; }

    Array.prototype.forEach.call(document.querySelectorAll(".hero-stats"), function (l) {
      bereiteZahlen(l);
    });
    bereiteKarten();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  /* Im Customizer wird eine Section beim Bearbeiten neu geladen. Der kurze
     Aufschub laesst das neue Markup erst fertig einhaengen. */
  document.addEventListener("shopify:section:load", function () { setTimeout(init, 50); });
})();
